/* eslint-disable no-shadow,no-unused-vars */
import Immutable from "immutable";
import api from "../../lib/api";

export const HYDRATE = "@app/profile/HYDRATE";
export const HYDRATE_SCHEMA = "@app/profile/HYDRATE_SCHEMA";
export const HYDRATE_ORDERS = "@app/profile/HYDRATE_ORDERS";

export const UPDATE = "@app/profile/UPDATE";

export const CREATE = "@app/profile/CREATE";

export const CREDENTIALS_UPDATE = "@app/profile/CREDENTIALS_UPDATE";

// ------------------------------------
// Action Generators
// ------------------------------------

export const hydrate = () => ({
  type: HYDRATE,
  payload: api.get("/me")
});

export const hydrateSchema = () => ({
  type: HYDRATE_SCHEMA,
  payload: api.get("/schema/Profile")
});

export const hydrateOrders = page => ({
  type: HYDRATE_ORDERS,
  payload: api.get("/me/orders", { page })
});

export const update = data => ({
  type: UPDATE,
  payload: api.put("/me", data)
});

export const create = data => ({
  type: CREATE,
  payload: api.post("/me", data)
});

export const updateCredentials = data => ({
  type: CREDENTIALS_UPDATE,
  payload: api.put("/me/credentials", data)
});

// ------------------------------------
// Intial State
// ------------------------------------
const State = new Immutable.Record({
  schema: Immutable.Map(),
  schemaError: null,
  schemaIsFetching: false,

  data: Immutable.Map(),
  dataError: null,
  dataIsFetching: false,

  dataIsUpdating: false,
  dataIsUpdated: false,

  dataIsCreating: false,
  dataIsCreated: false,

  credentials: Immutable.Map({
    isUpdating: false,
    isUpdated: false,
    error: ""
  }),
  errors: Immutable.Map(),
  orders: Immutable.Map({
    isFetching: false,
    hasFetched: false,
    error: "",
    items: Immutable.Map({
      meta: Immutable.Map({
        total: 0,
        page: 0,
        pageSize: 0,
        prevPage: 0,
        nextPage: 0
      }),
      data: Immutable.List()
    })
  })
});

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [HYDRATE_SCHEMA]: (state, { status, payload }) => {
    switch (status) {
      case "pending":
        return state.set("schemaIsFetching", true);
      case "success":
        return state.set("schemaIsFetching", false).set("schema", Immutable.fromJS(payload));
      case "error":
        return state.set("schemaIsFetching", false).set("schemaError", payload);
    }
    return state;
  },
  [HYDRATE]: (state, { status, payload }) => {
    switch (status) {
      case "pending":
        return state.set("dataIsFetching", true);
      case "success":
        return state.set("dataIsFetching", false).set("data", Immutable.fromJS(payload));
      case "error":
        return state.set("dataIsFetching", false).set("dataError", payload);
    }
    return state;
  },
  [UPDATE]: (state, { status, payload }) => {
    switch (status) {
      case "pending":
        return state.set("dataIsUpdating", true);
      case "success":
        return state
          .set("dataIsUpdating", false)
          .set("dataIsUpdated", true)
          .set("data", Immutable.fromJS(payload));
      case "error":
        return state.set("dataIsUpdating", false).set("dataError", payload);
    }
    return state;
  },
  [CREATE]: (state, { status, payload }) => {
    switch (status) {
      case "pending":
        return state.set("dataIsCreating", true);
      case "success":
        return state.set("dataIsCreating", false).set("dataIsCreated", true);
      case "error":
        return state.set("dataIsCreating", false).set("dataError", payload);
    }
    return state;
  },
  [CREDENTIALS_UPDATE]: (state, { status, payload }) => {
    switch (status) {
      case "pending":
        return state.setIn(["credentials", "isUpdating"], true).setIn(["credentials", "isUpdated"], false);
      case "success":
        return state.setIn(["credentials", "isUpdating"], false).setIn(["credentials", "isUpdated"], true);
      case "error":
        return state
          .setIn(["credentials", "isUpdating"], false)
          .setIn(["credentials", "isUpdated"], false)
          .setIn(["credentials", "error"], payload);
    }
    return state;
  },
  [HYDRATE_ORDERS]: (state, { status, payload }) => {
    switch (status) {
      case "pending":
        return state.setIn(["orders", "isFetching"], true);
      case "success":
        return state
          .setIn(["orders", "isFetching"], false)
          .setIn(["orders", "hasFetched"], true)
          .setIn(["orders", "items"], Immutable.fromJS(payload));
      case "error":
        return state.setIn(["orders", "isFetching"], false).setIn(["orders", "error"], payload);
    }
    return state;
  }
};

// ------------------------------------
// Reducer
// ------------------------------------
export default function reducer(state = new State(), action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
